import React from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

/**
 * "Type of Service" select.
 * Props:
 * - value: string
 * - onChange: (value: string) => void
 * - options: { value: string, label: string }[]
 */
const TicketTypeSelect = ({ value, onChange, options }) => (
  <div className="form-field">
    <label>Type of Service*</label>
    <Select
      id="ticketType"
      name="ticketType"
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      required
      displayEmpty
      fullWidth
      size="small"
      className="text-left"
    >
      <MenuItem className="w-100 text-left" value="" disabled>
        ---Select service---
      </MenuItem>
      {options.map((option, j) => (
        <MenuItem className="w-100 text-left" key={j} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  </div>
);

export default TicketTypeSelect;
